import React, { useState, useEffect } from "react";
import {
  TextInput,
  Create,
  FormTab,
  TabbedForm,
  useGetOne,
  useRedirect,
  SimpleForm,
  useNotify,
  Toolbar,
  SaveButton,
  ReferenceInput,
  SelectInput,
  useResourceContext,
  RefreshButton,
  ListButton,
  TopToolbar,
  TabbedShowLayout,
  Tab,
  Show,
  usePermissions,
} from "react-admin";
import Select from "react-select";
import MomentUtils from "@date-io/moment";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import { Papa } from "../common/common";
import moment from "moment";
import StarIcon from "@mui/icons-material/Star";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import SrvPageImg from "../../src/images/srv-page.png"
import {
  DatePicker,
  DateTimePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
// const cardActionStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const CreateActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={`/surveys`} />
  </TopToolbar>
);

const EditTitle = ({ record }) => {
  return <span>Edit Survey</span>;
};

const SurveysEdit = ({ ...props }) => {
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const surveyId = pathSplit[2];
  const permissions = usePermissions();

  // const [dataFromParams] = useState(parsedUrl ? JSON.parse(parsedUrl.source): '');
  const [dataFromParams] = useState(surveyId ? surveyId : "");

  // const surveyDataById = useGetOne({
  //     type: 'getList',
  //     resource: `surveys/${dataFromParams.id}`,
  //     payload: { id: 1 }
  // });
  // const surveyDataById = useGetOne("surveys", { id: dataFromParams });
  const [surveyDataById, setSurveyDataById] = useState([]);
  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/surveys/${dataFromParams}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        setSurveyDataById(jsonD);
        console.log("obj==>", jsonD);
      });
  }, []);

  // const surveyTargetedFeaturesData = useGetOne({
  //     type: 'getList',
  //     resource: `survey_targeted_features`,
  //     payload: { id: 1 }
  // });
  // const surveyTargetedFeaturesData = useGetOne("survey_targeted_features" , {id : ''});
  const [surveyTargetedFeaturesData, setSurveyTargetedFeaturesData] = useState(
    []
  );
  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/survey_targeted_features`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        setSurveyTargetedFeaturesData(jsonD);
        console.log("obj==>", jsonD);
      });
  }, []);

  // const businessListData = useGetOne({
  //     type: 'getList',
  //     resource: `so_business_list`,
  //     payload: { id: 1 }
  // });
  // const businessListData = useGetOne("so_business_list" , {id : ''});
  const [businessListData, setBusinessListData] = useState([]);
  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        setBusinessListData(jsonD);
        console.log("obj==>", jsonD);
      });
  }, []);

  console.log(
    "xxxcccc cc",
    surveyDataById,
    surveyTargetedFeaturesData,
    businessListData,
    "....."
  );

  useEffect(() => {
    console.log("surveyTargetedFeaturesData", surveyTargetedFeaturesData);
    const list =
      surveyTargetedFeaturesData &&
      surveyTargetedFeaturesData.data &&
      surveyTargetedFeaturesData.data.map((i) => ({
        id: i.id,
        value: i.description,
        label: i.description,
      }));
    setSurveyTargetedFeaturesList(list);
  }, [surveyTargetedFeaturesData]);

  useEffect(() => {
    const { data } = surveyDataById;
    console.log("fffffffffffffffffffffffffffffffffffffff", surveyDataById);
    if (
      saleOffNameSapCode &&
      saleOffNameSapCode.length > 0 &&
      data &&
      Object.keys(data).length > 0
    ) {
      if (data.survey_mappped_type === "Business") {
        const addedRetailer = saleOffNameSapCode.filter((i) =>
          data.survey_mapping.find((el) => el.principle_id === i.id)
        );
        setRetailerList(addedRetailer);
      }
      setPurpose(data.purpose);
      setPopupText(data.popup_text);
      setTargetedFeature({
        id: data.survey_targeted_feature_id,
        label: data.targeted_feature,
        value: data.targeted_feature,
      });
      setSurveyType(data.survey_type)
      const startTimeArr = data.start_time.split(':')
      const sStartTime = moment().set({"hour": startTimeArr[0], "minute": startTimeArr[1]})

      const endTimeArr = data.end_time.split(':')
      const sEndTime = moment().set({"hour": endTimeArr[0], "minute": endTimeArr[1]})

      setStartDate(new Date(data.start_date));
      setEndDate(new Date(data.end_date));
      setStartTime(new Date(sStartTime));
      setEndTime(new Date(sEndTime));
      setMinDate(new Date(data.start_date));      
    }
  }, [surveyDataById, businessListData]);

  const businessData = businessListData && businessListData.data;
  const originalRetList =
    businessData &&
    businessData.map((item) => ({
      id: item.id,
      value: item.label,
      label: item.label,
      sap: item.sap_code.trim(),
    }));
  const saleOffNameSapCode =
    businessData &&
    businessData.map((item) => ({
      id: item.id,
      value: item.label,
      label: item.label,
      sap: item.sap_code.trim(),
    }));

  const [purpose, setPurpose] = useState("");
  const [popupText, setPopupText] = useState("");
  const [targetedFeature, setTargetedFeature] = useState({});
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startTime, setStartTime] = useState(moment(new Date()).startOf("day"));
  const [endTime, setEndTime] = useState(moment(new Date()).endOf("day"));
  const [minDate, setMinDate] = useState(new Date());
  const [surveyTargetedFeaturesList, setSurveyTargetedFeaturesList] = useState(
    []
  );
  const [surveyType, setSurveyType] = useState("rating");

  const [type, setType] = useState("");
  const [originalList, setOriginalList] = useState(originalRetList);

  const [saveValid, setSaveValid] = useState(false);

  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] =
    useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] =
    useState(false);

  const [retailerList, setRetailerList] = useState([]);
  // const [retailerNameSapCode, setRetailerNameSapCode] = useState([])

  const [loader, setLoader] = useState(false);

  const redirectTo = useRedirect();
  const notify = useNotify();
  const resource = useResourceContext();

  // useEffect(() => {
  //     console.log('surveyTargetedFeaturesData', surveyTargetedFeaturesData);
  //     const list = surveyTargetedFeaturesData && surveyTargetedFeaturesData.data && surveyTargetedFeaturesData.data.map(i => ({ id: i.id, value: i.description, label: i.description }));
  //     setSurveyTargetedFeaturesList(list);
  // }, [surveyTargetedFeaturesData])

  // useEffect(() => {
  //     const { data } = surveyDataById;
  //     if (saleOffNameSapCode && saleOffNameSapCode.length > 0 && data && Object.keys(data).length > 0) {

  //         if (data.survey_mappped_type === 'Business') {
  //             const addedRetailer = saleOffNameSapCode.filter(i => data.survey_mapping.find(el => el.principle_id === i.id))
  //             setRetailerList(addedRetailer);
  //         }
  //         setPurpose(data.purpose);
  //         setPopupText(data.popup_text);
  //         setStartDate(data.start_date);
  //         setEndDate(data.end_date);
  //         setStartTime(data.start_time)
  //         setEndTime(data.end_time);
  //         setTargetedFeature({ id: data.survey_targeted_feature_id, label: data.targeted_feature, value: data.targeted_feature })
  //         setSurveyType(data.survey_type);

  //         const ctrDate = moment(new Date()).format('YYYY-MM-DD')
  //         if (ctrDate >= data.start_date) {
  //             setMinDate(data.start_date)
  //             console.log('data.start_date', data.start_date);
  //         } else {
  //             setMinDate(ctrDate)
  //             console.log('ctrDate', ctrDate)
  //         }
  //         setType(data.survey_mappped_type);
  //     }
  // }, [surveyDataById, businessListData])

  const saveData = (e) => {
    const { data } = surveyDataById;
    e.preventDefault();
    setLoader(true);
    // console.log('targetedFeature', targetedFeature[0].id);
    const formData = new FormData();
    formData.append("purpose", purpose);
    formData.append("popup_text", popupText);
    formData.append(
      "targeted_feature",
      (targetedFeature && targetedFeature[0] && targetedFeature[0].id) || null
    );
    formData.append("start_date", moment(startDate));
    formData.append("end_date", moment(endDate));
    formData.append("start_time", moment(startTime).format("HH:mm:ss"));
    formData.append("end_time", moment(endTime).format("HH:mm:ss"));
    formData.append("type", type);
    formData.append("survey_type", surveyType);
    formData.append(
      "name_sap_code",
      type === "Country" ? [] : JSON.stringify(retailerList)
    );

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;
    const options = {};
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "PUT";

    options.body = formData;
    fetch(`${apiUrl}/surveys/${data && data.id}`, {
      method: "PUT",
      body: formData,
      headers: {
        Authorization: userData._token,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        notify("ra.notification.updated", "info", {
          smart_count: 1,
        });
        setLoader(false);
        redirectTo("list", resource);
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  };

  const handleChange = (e) => {
    const arr = [...originalRetList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalRetList];
    }
    setRetailerList(e);
    // setRetailerNameSapCode(result)
  };

  const handleRetailCSVFile = (e) => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    // console.log('file inside survey===>', file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length));
    if (
      file === null ||
      typeof file === "undefined" ||
      file === "" ||
      typeof file === undefined ||
      fileType.toLowerCase() !== "csv"
    ) {
      Swal.fire({
        text: "Please choose a valid .csv file.",
        confirmButtonText: `OK`,
        icon: "error",
      });
      file = null;
      console.log("bad file");
    } else {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
          if (
            checkValidHeader.includes("COMPANYNAME") &&
            checkValidHeader.includes("SAPID")
          ) {
            const parseddata =
              permissions.permissions === "isSap"
                ? results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + "-0000" + item.SAPID,
                    label: item.COMPANYNAME + "-0000" + item.SAPID,
                    sap: "0000" + item.SAPID.trim(),
                  }))
                : results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + " " + item.SAPID,
                    label: item.COMPANYNAME + " " + item.SAPID,
                    sap: item.SAPID.trim(),
                  }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            pasrsedSimilarData = originalRetList.filter((a1) =>
              parseddata.some((a2) => a1.sap === a2.sap)
            );
            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray =
                retailerList !== null
                  ? retailerList.filter(
                      ({ sap: id1 }) =>
                        !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)
                    )
                  : [];
              setRetailerList([...similarArray, ...pasrsedSimilarData]);
              setPasrsedSimilarDataLength(pasrsedSimilarData.length);
            }
            const pasrsedDifferentData = parseddata.filter((a1) =>
              pasrsedSimilarData.every((a2) => a1.sap !== a2.sap)
            );
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length);
              setUnregisteredRetailers([...pasrsedDifferentData]);
              setPasrsedDifferentDataLength(pasrsedDifferentData.length);
            }
          } else {
            Swal.fire({
              text: "File headers do not match. Kindly download and refer the sample file.",
              confirmButtonText: `OK`,
              icon: "error",
            });
          }
        },
      });
    }
  };

  const cancelClick = (e) => {
    e.preventDefault();
    setRetailerList([]);
    // setRetailerNameSapCode(originalList);
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);
  };

  const handleChangeTargetedFeature = (e) => {
    setTargetedFeature([e]);
  };

  useEffect(() => {
    let valid = !!purpose && !!popupText && !!type;
    if (type === "Business") {
      valid = valid && retailerList && retailerList.length > 0;
    }
    setSaveValid(valid);
  }, [popupText, purpose, type, retailerList]);
  console.log("targetedFeature===>", targetedFeature);
  return (
    <Show
      {...props}
      title={<EditTitle />}
      actions={<CreateActions permissions={permissions.permissions} />}
    >
      <TabbedShowLayout className="promotion-editpage">
        <Tab label="① Edit">
          <div className="so-input">
            <label>
              Purpose<sup className="asterisk">*</sup>
            </label>
            <input
              type="text"
              name="Purpose"
              value={purpose}
              onChange={(e) => {
                setPurpose(e.target.value);
              }}
            />
          </div>
          <div className="so-input">
            <label>
              survey type<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              disabled
              name="type"
              value={surveyType}
              onChange={(e) => {
                setSurveyType(e.target.value);
              }}
            >
              <option value="">Select Option</option>
              <option value="rating">Rating</option>
              <option value="question">Question</option>
            </select>
          </div>
          <div className="so-input">
            <label>
              {surveyType === "rating" || surveyType === ""
                ? "Popup Text"
                : "Question Text"}
              <sup className="asterisk">*</sup>
            </label>
            <input
              type="text"
              name="Popup Text"
              value={popupText}
              onChange={(e) => {
                setPopupText(e.target.value);
              }}
            />
          </div>
          <div className="so-input">
            <label className="target-feature-label">
              Targeted Feature<sup className="asterisk">*</sup>
            </label>
            <Select
              isDisabled
              value={targetedFeature}
              onChange={handleChangeTargetedFeature}
              options={surveyTargetedFeaturesList}
              isMulti={false}
            />
          </div>
          <div className="promotion-date">
            <div>
              <p className="upload-files-label">
                Start Date<sup className="asterisk">*</sup>
              </p>
              {/* <LocalizationProvider utils={MomentUtils}> */}
                <DatePicker
                  disabled
                  value={startDate}
                  onChange={(e) => setStartDate(e)}
                  format="dd/MM/yyyy"
                  minDate={minDate}
                />
              {/* </LocalizationProvider> */}
            </div>
            <div>
              <p className="upload-files-label">
                End Date<sup className="asterisk">*</sup>
              </p>
              {/* <LocalizationProvider utils={MomentUtils}> */}
                <DatePicker
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                  format="dd/MM/yyyy"
                  minDate={startDate}
                />
              {/* </LocalizationProvider> */}
            </div>
          </div>
          <div className="promotion-date">
            <div>
              <p className="upload-files-label">
                Start Time<sup className="asterisk">*</sup>
              </p>
              {/* <LocalizationProvider utils={MomentUtils}> */}
                <TimePicker
                  value={startTime}
                  onChange={(e) => setStartTime(e)}
                  format="HH:mm"
                  // minDate={new Date()}
                  // maxDate={endDate}
                />
              {/* </LocalizationProvider> */}
            </div>
            <div>
              <p className="upload-files-label">
                End Time<sup className="asterisk">*</sup>
              </p>
              <LocalizationProvider utils={MomentUtils}>
                <TimePicker
                  value={endTime}
                  onChange={(e) => setEndTime(e)}
                  format="HH:mm"
                  minDate={startTime}
                  // maxDate={this.state.toDate}
                />
              </LocalizationProvider>
            </div>
          </div>
          {surveyType === "rating" || surveyType === "" ? (
            <div className="create-rating-popup">
              <div className="rating-popup">
                <img className="item-center" src={SrvPageImg} />
                <p className="text-center">{popupText}</p>
                <p className="text-center">
                  {<StarIcon />}
                  {<StarIcon />}
                  {<StarIcon />}
                  {<StarIcon />}
                  {<StarIcon />}
                </p>
                <div className="rating-comment">
                  <p className="comment-label">Comment (optional)</p>
                  <textarea className="srv-textarea" placeholder="Share feedback....." disabled />
                </div>
                <div className="rating-pop-buttons">
                <div>
                    <button
                      className="rating-cancel-btn"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <span>Cancel</span>
                    </button>
                  </div>
                  <div>
                    <button
                      className="rating-submit-btn"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <span>Submit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="create-rating-popup">
              <div className="rating-popup">
                <img className="item-center" src={SrvPageImg} />
                <p className="text-center">{popupText}</p>
                <div className="rating-answer">
                  <div className="srv-yes-no">
                    <input type="radio" disabled />
                    <label>Yes</label>
                  </div>
                  <div className="srv-yes-no">
                    <input type="radio" disabled />
                    <label>No</label>
                  </div>
                </div>
                <div className="rating-comment">
                  <p className="comment-label">Comment (optional)</p>
                  <textarea className="srv-textarea" placeholder="Share feedback....." disabled />
                </div>
                <div className="rating-pop-buttons">
                <div>
                    <button
                      className="rating-cancel-btn"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <span>Cancel</span>
                    </button>
                  </div>
                  <div>
                    <button
                      className="rating-submit-btn"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <span>Submit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="so-save-button">
            {loader ? (
              <div className="save-loader" />
            ) : (
              <button onClick={saveData} disabled={!saveValid}>
                <span>Save</span>
              </button>
            )}
          </div>
        </Tab>
        <Tab label="② Send To">
          <div className="so-input">
            <label>
              Send To<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              name="type"
              value={type}
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <option value="">Select Option</option>
              <option value="Country">All Retailers</option>
              <option value="Business">A set of Retailers</option>
            </select>
          </div>
          {type === "Business" && (
            <div>
              <div className="csv-file-upload-container target-upload-container">
                <label>Upload File</label>
                {/* <input type="file" accept=".csv" name="flies[]" /> */}
                <input
                  type="file"
                  id="file"
                  accept=".csv"
                  onChange={handleRetailCSVFile}
                />
                <div className="valid-file-upload">
                  <p>Instructions :</p>
                  <ul>
                    <li>Only CSV files are allowed with Comma as separator.</li>
                  </ul>
                </div>
                <div className="upload-file-format-download">
                  <p>
                    To get upload file format.{" "}
                    <a
                      href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                      target="_blank"
                    >
                      Click here
                    </a>{" "}
                    to download
                  </p>
                </div>
              </div>
              <div>
                {pasrsedSimilarDataLength > 0 ||
                pasrsedDifferentDataLength > 0 ? (
                  <div className="csv-result-container">
                    <label>CSV Result</label>
                    <div className="csv-result">
                      <div>
                        <p
                          onClick={() =>
                            setUnregisteredRetailersToggle(
                              !unregisteredRetailersToggle
                            )
                          }
                        >
                          {pasrsedSimilarDataLength} retailers found,{" "}
                          {pasrsedDifferentDataLength} retailers unregistered.
                          {pasrsedDifferentDataLength > 0
                            ? " Click to view unregistererd retailers"
                            : ""}
                          {pasrsedDifferentDataLength > 0 ? (
                            <span
                              className={
                                unregisteredRetailersToggle
                                  ? `icon-arrow_down`
                                  : `icon-arrow_up`
                              }
                            />
                          ) : (
                            ""
                          )}
                        </p>
                        {pasrsedDifferentDataLength > 0 ? (
                          <div
                            className={
                              unregisteredRetailersToggle
                                ? `hide-unregistered`
                                : `show-unregistered`
                            }
                          >
                            <React.Fragment>
                              {unregisteredRetailers.map((item) => (
                                <p key={item.id}>{item.label}</p>
                              ))}
                            </React.Fragment>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <label className="select-label">
                Choose Retailers<sup className="asterisk">*</sup> (Atleast
                select one retailer)
              </label>
              <div className="select-retailer">
                <Select
                  value={retailerList}
                  onChange={handleChange}
                  options={saleOffNameSapCode}
                  isMulti
                />
                <button onClick={(e) => cancelClick(e)}>Clear</button>
              </div>
            </div>
          )}
          <div className="so-save-button">
            {loader ? (
              <div className="save-loader" />
            ) : (
              <button onClick={saveData} disabled={!saveValid}>
                <span>Save</span>
              </button>
            )}
          </div>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default SurveysEdit;
